export enum LoanPaymentStatus {
	NOT_YET_PAID = 'NOT_YET_PAID',
	PARTIALLY_PAID = 'PARTIALLY_PAID',
	SCHEDULED = 'SCHEDULED',
	FULLY_PAID = 'FULLY_PAID',
	FEES_OWED = 'FEES_OWED',
	OVERDUE = 'OVERDUE',
	CLOSED = 'CLOSED',
}
